import React from 'react';
import {getDate} from "../../../../assets/js/date-time-converter";
import StartDateGroup from "../../../module-planner/module-schedule/start-date-group";
import AnimateHeight from "react-animate-height";

class ModuleScheduleItem extends React.Component {
    constructor(props) {
        super(props);

        const {isInitiallyOpen = false} = this.props;

        this.state = {
            startDateItemActive: false,
            isOpen: isInitiallyOpen,
        };
    }

    toggleModuleItem = e => {
        e.preventDefault();

        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    onHandleCourseClick = (e, moduleScheduleItemSku, startDateItemCourseId) => {
        this.setState({
            isOpen: false
        });

        this.props.handleCourseClick(e, moduleScheduleItemSku, startDateItemCourseId)
    };

    renderAvailableDates = (moduleScheduleItem) => {
        const {textsMapping} = this.props;
        //Sorting by city alphabetically
        moduleScheduleItem.availableStartDates.sort((a, b) => a.city.localeCompare(b.city));

        let groupedStartDates = [];

        // Create grouped Objects by city
        moduleScheduleItem.availableStartDates.forEach(function (a) {
            groupedStartDates[a.city] = groupedStartDates[a.city] || [];
            groupedStartDates[a.city].push(a);
        });

        return Object.entries(groupedStartDates).map(([key, value]) => {
            return (
                <StartDateGroup
                    key={key}
                    city={key}
                    groupedStartDates={value}
                    moduleScheduleItem={moduleScheduleItem}
                    resourcedTexts={textsMapping}
                    handleCourseClick={this.onHandleCourseClick}
                />
            )
        })
    };

    getSelectedCourseId = (product, selectedCourse) => {
        let selectedCourseDate, selectedCity;
        if (product === undefined || selectedCourse === undefined || selectedCourse === "") {
            return false
        }

        function findCourse(startDateItem) {
            return startDateItem.courseId === product.selectedCourseId;
        }

        selectedCourseDate = product.availableStartDates.find(findCourse);

        if (selectedCourseDate === undefined) {
            return false;
        }

        selectedCity = selectedCourseDate.city;
        selectedCourseDate = getDate(selectedCourseDate.startDateList[0].startTime);

        return <span>{selectedCity}, {selectedCourseDate}</span>;
    };

    render() {
        const {item: moduleScheduleItem, textsMapping, isInvalid} = this.props;
        const {isOpen} = this.state;
        const itemContentHeight = isOpen ? 'auto' : 0;

        let selectedCourse = moduleScheduleItem.selectedCourseId !== "";

        return (
            <div
                className={`module-schedule__item ${selectedCourse ? 'has-selected-course' : ""} ${isOpen ? 'is-open' : ''}`}
                key={`moduleScheduleItem${moduleScheduleItem.sku}`}
            >
                <a href="#" className={`module-schedule__item-header ${isInvalid ? 'module-schedule__item-header--invalid' : ""}`}
                   onClick={(e) => this.toggleModuleItem(e)}>
                    <div className={`module-schedule__item-header-content`}>
                        <div className="module-schedule__item-title">
                            {moduleScheduleItem.title}
                        </div>
                        <div
                            className={`module-schedule__item-selected-startdate ${!selectedCourse ? 'no-startdate-selected' : ''} ${isOpen ? 'is-open' : ''}`}>
                            {selectedCourse
                                ? this.getSelectedCourseId(moduleScheduleItem, moduleScheduleItem.selectedCourseId)
                                : textsMapping.moduleSchedulePickStartDateText
                            }
                        </div>
                    </div>

                    {selectedCourse
                        ? (
                            <div className="module-schedule__item-edit">
                                {textsMapping.moduleScheduleEditStartDateText}
                            </div>
                        ) : null
                    }
                    <span className="module-schedule__item-trigger"/>
                </a>
                <AnimateHeight
                    duration={400}
                    height={itemContentHeight}
                >
                    <div className="module-schedule__item-content">
                        {this.renderAvailableDates(moduleScheduleItem)}
                    </div>
                </AnimateHeight>
            </div>
        )
    }
}

export default ModuleScheduleItem;